import {getUrlParam, removeUrlParameter} from "@/services/helper";

export function getPromo() {
    const urlParam = 'promo';
    return getUrlParam(urlParam);
}

export function removePromo() {
    const urlParam = 'promo';
    removeUrlParameter(urlParam);
}